import { useMemo } from 'react';
import type { IModuleDefinition, IRecord } from '@platform/core/types';
import { useListRecordsQuery } from '@platform/state/api';
import type { IVizRecords } from './IVizRecords';
import { vizSourceOf } from './vizSourceOf';

/**
 * Записи дочірньої таблиці модуля для діаграми (прототип v4 vizVals): ті, що посилаються на запис діаграми (до 100, за кодом);
 * `skipArchived` — без архівних (причини fishbone, елементи SWOT).
 */
export function useVizRecords(ws: string, module: IModuleDefinition, rtKey: string, record: IRecord, field: string, skipArchived = false): IVizRecords {
  const source = useMemo(() => vizSourceOf(module, rtKey, field), [module, rtKey, field]);
  const { data, isLoading } = useListRecordsQuery(
    { ws, rt: source?.rt.key ?? '', params: { filter: `${source?.ref ?? ''}:eq:${record.id}`, pageSize: 100, sort: 'code', facets: false } },
    { skip: !source || !record.id },
  );
  const items = useMemo(() => (data?.items ?? []).filter((r) => !skipArchived || r.status !== 'Archived'), [data, skipArchived]);
  return { source, items, loading: isLoading };
}
